<template>
  <div>
    <div class="container">
      <el-dialog :title="'区域'" :visible.sync="isShow" :close-on-click-modal="false">
        <el-form :model="form" ref="form" :rules="rules">
          <div class="form_data">
            <el-form-item label="名称:" prop="arealRainfallName">
              <el-input v-model="form.arealRainfallName"></el-input>
            </el-form-item>
            <el-form-item label="是否首页显示:" prop="isDisplay">
              <el-radio-group v-model="form.isDisplay">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isShow = false">取 消</el-button>
          <el-button type="primary" @click="save">保 存</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import usercenterType from '@/store/types/usercenter'
export default {
  data () {
    return {
      isShow: false,
      form: {},
      rules: {
        arealRainfallName: [
          { required: true, message: '名称不能为空' }
        ]
      }
    }
  },
  methods: {
    save () {
      this.$refs['form'].validate(async valid => {
        if (valid) {
          let result = await this.$store.dispatch(
            usercenterType.postArealRainfallInfo,
            this.form
          )
          if (result.isSuccess) {
            this.$notify.success({ title: '成功', message: '保存成功' })
            this.isShow = false
            this.$emit('getData')
          } else {
            this.$notify.error({ title: '失败', message: '保存失败' })
          }
        }
      })
    }
  }
}
</script>

<style>
</style>
<style lang="less" src="@/assets/usercenter.less" scoped></style>
